import React, { useEffect, useState } from "react";
import { Typography, Stack, Box, Grid } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { useQuery } from "@apollo/client";
import momentkh from "@thyrith/momentkh";
import moment from "moment";
//Srcs
import "../../Style/pagestyle.scss";
import school from "../../Assets/goglobal-school.png";
import symbol from "../../Assets/tacteing.jpg";
import EmptyData from "../Include/EmptyData";
import LoadingPage from "../Include/LoadingPage";
import { getKhmerMonth, getKhmerNumber } from "../../Function/DynamicFn";
import { GET_STUDENT_ENROLLMENT_BY_CLASSGROUP } from "../../Schema/Report";

function loop_elements(countValue) {
  let row = [];
  for (let i = 0; i < countValue?.length; i++) {
    row.push(i);
  }
  return row;
}

export default function StudentStatisticByClassgroup({
  academicYearVal,
  oldAcademicYearVal,
  programmeId,
  classgroupId,
  componentRef,
  tableRef,
  classGroupName
}) {

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalData, setTotalData] = useState({});
  const [classData, setClassData] = useState([]);

  const [khmerDateString, setKhmerDateString] = useState("");
  const [mondayDateString, setMondayDateString] = useState("");
  const [checkMonth, setCheckMonth] = useState("");
  useEffect(() => {
    let khMoment = momentkh(moment);
    setCheckMonth(khMoment()?.toLunarDate("m"));
  }, []);

  useEffect(() => {
    if (checkMonth) {
      let khMoment = momentkh(moment);
      setKhmerDateString(khMoment()?.toLunarDate(`ថ្ងៃW dN ខែ${checkMonth === "កក្ដិក" ? "កត្តិក" : checkMonth} ឆ្នាំa e ព.ស.b`));
      setMondayDateString(khMoment()?.toLunarDate(` dN ខែ${checkMonth === "កក្ដិក" ? "កត្តិក" : checkMonth} ឆ្នាំa e ព.ស.b`));
    }
  }, [checkMonth]);

  const { refetch } = useQuery(
    GET_STUDENT_ENROLLMENT_BY_CLASSGROUP,
    {
      variables: {
        academicYearId: academicYearVal?.id,
        oldAcademicYearId: oldAcademicYearVal?.id,
        programmeId: programmeId,
        classgroupId: classgroupId,
      },
      onCompleted: ({ getStudentRegisterByClassgroupAccounting }) => {
        // console.log("working....")
        setLoading(false);
        // console.log("getStudentRegisterByClassgroupAccounting::", getStudentRegisterByClassgroupAccounting)
        setTableData(getStudentRegisterByClassgroupAccounting?.dataByGrade);
        setTotalData(getStudentRegisterByClassgroupAccounting?.totalData)

        if (getStudentRegisterByClassgroupAccounting?.dataByGrade?.length > 0) {
          let rowOfReport = [];
          getStudentRegisterByClassgroupAccounting?.dataByGrade?.map(
            (gradeElement, indexGrade) => {
              if (gradeElement?.dataByClass?.length > 0) {
                gradeElement?.dataByClass?.map(
                  (classElement, indexClass) => {
                    // console.log("classElement::", classElement)
                    const allRow = {
                      gradeName: gradeElement?.gradeName,
                      className: classElement?.className,
                      roomNumber: classElement?.roomNumber,
                      studyShift: classElement?.studyShift,
                      totalByOldAcademicYear: classElement?.totalByOldAcademicYearAndMonth,
                      totalByType: classElement?.totaByTypeAndMonth,
                      totalNewStudentByGrade: classElement?.totalNewStudentByMonth,
                      totalOldStudentByGrade: classElement?.totalOldStudentByMonth,
                      totalReEnrollStudentByGrade: classElement?.totalReEnrollStudentByMonth,
                      totalAddProgrammeStudentByGrade: classElement?.totalAddProgrammeStudentByMonth,
                      totalChangeProgrammeStudentByGrade: classElement?.totalChangeProgrammeStudentByMonth,
                      totalByMonth: classElement?.totalByMonth,
                    };
                    if (rowOfReport?.length === 0) {
                      rowOfReport?.push(allRow);
                    } else if (rowOfReport?.length > 0) {
                      let filterHaveGradeClass = rowOfReport?.filter(
                        (e) =>
                          e?.gradeName === allRow?.gradeName &&
                          e?.className === allRow?.className
                      );

                      if (filterHaveGradeClass?.length === 0) {
                        rowOfReport?.push(allRow);
                      }
                    }
                  }
                );
              } else {
                const allRow = {
                  gradeName: gradeElement?.gradeName,
                  className: "",
                  roomNumber: "",
                  studyShift: "",
                  totalByOldAcademicYear: 0,
                  totalByType: 0,
                  totalNewStudentByGrade: 0,
                  totalOldStudentByGrade: 0,
                  totalReEnrollStudentByGrade: 0,
                  totalAddProgrammeStudentByGrade: 0,
                  totalChangeProgrammeStudentByGrade: 0,
                  totalByMonth: [],
                };

                if (rowOfReport?.length === 0) {
                  rowOfReport?.push(allRow);
                } else if (rowOfReport?.length > 0) {
                  let filterHaveGradeClass = rowOfReport?.filter(
                    (e) =>
                      e?.gradeName === allRow?.gradeName &&
                      e?.className === allRow?.className
                  );
                  if (filterHaveGradeClass?.length === 0) {
                    rowOfReport?.push(allRow);
                  }
                }
              }
            }
          )
          setClassData([...rowOfReport]);
        } else {
          setClassData([]);
        }
      },
      onError: (err) => {
        console.log("Error::", err?.message);
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [academicYearVal?.id, oldAcademicYearVal?.id, programmeId, classgroupId]);

  const startYear = academicYearVal?.title?.slice(0, 4) || "";
  const endYear = academicYearVal?.title?.slice(5, 9) || "";

  // console.log("totalData::", totalData)
  // console.log("tableData::", tableData)
  // console.log("classData::", classData)

  const totalStuByMonthAndGrade = (monthElement, gradeData) => {

    const totalByMonthData = gradeData?.map((rowClass) => {
      const findByMonthAndYear = rowClass?.totalByMonth.find(
        (elem) =>
          elem.yearName === monthElement.yearName &&
          elem.monthName === monthElement.monthName
      );
      // console.log("findByMonthAndYear::", findByMonthAndYear)
      return findByMonthAndYear?.total
    })
    // console.log('totalByMonthData::', totalByMonthData)

    const totalByGrade = totalByMonthData.reduce(
      (a, b) => a + b,
      0
    );

    return totalByGrade
  }

  const prepareClassData = classData?.map((row) => {
    // console.log("row::", row)
    return {
      className: row?.gradeName + " " + row?.className,
      totalOldAcademicStu: row?.totalByOldAcademicYear,
      totalStuByType: row?.totalByType,
    }
  })

  // console.log("prepareClassData::", prepareClassData)

  let colors = ["#3C8FB9", "#E18918"];

  const state = {
    series: [
      {
        name: oldAcademicYearVal?.title,
        data: prepareClassData?.map((group) => group.totalOldAcademicStu),
      },
      {
        name: "ជាក់ស្តែង",
        data: prepareClassData?.map((group) => group.totalStuByType),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 360,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          endingShape: "rounded",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "14px",
          fontFamily: "Siemreap !important",
          colors: ["#304758"],
        },
        formatter: function (val) {
          return `${val}`;
        },
      },
      colors: colors,
      xaxis: {
        categories: prepareClassData?.map((group) => group.className),
        labels: {
          style: {
            fontSize: "12px",
            fontFamily: "Siemreap !important",
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " pax";
          },
        },
      },
    },
  };


  return (
    <Box sx={{ marginTop: "20px" }} ref={componentRef}>
      <Box
        sx={{ bgcolor: "#fff", borderRadius: "10px" }}
        className="dibursement-print-container"
      >
        <Grid container>
          <Grid item xs={3}>
            <Stack direction="column">
              <img
                src={school}
                alt="school"
                className="logo-size"
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack direction="column">
              <Stack justifyContent="center" alignItems="center">
                <Typography className="disbursement-title-kh">
                  ព្រះរាជាណាចក្រកម្ពុជា
                </Typography>
                <Typography className="disbursement-title">
                  Kingdom Of Cambodia
                </Typography>
                <Typography className="disbursement-title-kh">
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </Typography>
                <Typography className="disbursement-title">
                  Nation Region King
                </Typography>
                <img src={symbol} alt="" width="110px" />
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          marginTop="15px"
          spacing={0.5}
        >
          <Typography className="disbursement-table-title">
            ស្ថិតិសិស្សតាមថ្នាក់ឆ្នាំសិក្សា{" "}
            {getKhmerNumber(startYear) + " - " + getKhmerNumber(endYear)}
          </Typography>
          <Typography className="disbursement-table-title-header">
            កម្រិត {classGroupName}
          </Typography>
          <Typography className="disbursement-table-title-header">
          </Typography>
        </Stack>
        <Box sx={{ marginTop: "10px" }} justifyContent="center">
          <Box ref={tableRef}>
            <table style={{ width: "100%", display: "none" }}>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={9 + tableData?.totalNum?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  ព្រះរាជាណាចក្រកម្ពុជា
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9 + tableData?.totalNum?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  Kingdom Of Cambodia
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9 + tableData?.totalNum?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  ជាតិ សាសនា ព្រះមហាក្សត្រ
                </td>
              </tr>
              <tr>
                <td
                  colSpan={9 + tableData?.totalNum?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  Nation Region King
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
              <tr>
                <td
                  colSpan={9 + tableData?.totalNum?.length * 2}
                  style={{ textAlign: "center" }}
                >
                  ស្ថិតិសិស្សចុះឈ្មោះតាមថ្នាក់ឆ្នាំសិក្សា ២០២៤-២០២៥
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </table>

            <table className="table-report-student-statistic-by-class">
              <tr>
                <th
                  style={{ width: "3%" }}
                  rowSpan={2}
                >
                  ល.រ
                </th>
                <th
                  style={{ width: "10%" }}
                  rowSpan={2}
                >
                  កម្រិត
                </th>
                <th
                  style={{ width: "3%" }}
                  rowSpan={2}
                >
                  ថ្នាក់
                </th>
                <th
                  style={{ width: "5%" }}
                  rowSpan={2}
                >
                  វេន
                </th>
                <th
                  style={{ width: "4%" }}
                  rowSpan={2}
                >
                  បន្ទប់
                </th>
                <th
                  style={{ width: "6%" }}
                  rowSpan={2}
                >
                  {/* {getKhmerNumber(startOldYear) +
                    " - " +
                    getKhmerNumber(endOldYear)} */}
                  {oldAcademicYearVal?.title}
                </th>
                <th
                  style={{ width: "69%" }}
                  colSpan={!totalData ? 6 : totalData?.totalByMonth?.length + 6}
                >
                  {academicYearVal?.title}
                </th>
              </tr>

              <tr>
                <th>ជាក់ស្តែង</th>
                <th>សិស្សចាស់</th>
                <th>សិស្សថ្មី</th>
                <th>Re-Enroll</th>
                <th>ថែមកម្មវិធី</th>
                <th>ប្តូរកម្មវិធី</th>
                {totalData?.totalByMonth?.map((e, index) => {
                  return (
                    <th
                      key={index}
                      style={{ width: totalData?.totalByMonth?.length > 10 ? "3%" : "6%" }}
                    >
                      {getKhmerMonth(e?.monthName?.toString())}
                    </th>
                  );
                })}
              </tr>

              {
                loading ?
                  <tr>
                    <td colSpan={20}>
                      <LoadingPage />
                    </td>
                  </tr>
                  : tableData === undefined ?
                    <tr>
                      <td colSpan={20}>
                        <EmptyData />
                      </td>
                    </tr> :
                    <>
                      <tr>
                        <th colSpan={5} style={{ backgroundColor: "#ecece0" }}>Total All</th>
                        {/* <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>0</th> */}
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalByOldAcademicYear}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalByType}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalNewStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalOldStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalReEnrollStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalAddProgrammeStudent}
                        </th>
                        <th style={{ backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}>
                          {totalData?.totalChangeProgrammeStudent}
                        </th>
                        {totalData?.totalByMonth?.map((d, index) => {
                          return (
                            <th
                              key={index}
                              style={{ width: "2%", backgroundColor: "#ecece0", color: "red", fontWeight: "bold" }}
                            >
                              {d?.total}
                            </th>
                          );
                        })}
                      </tr>

                      {tableData?.map((grade, indexGrade) => {
                        //====================================== filter grade name ==========================
                        const rowGrade = classData?.filter(
                          (e) => e?.gradeName === grade?.gradeName
                        );
                        // console.log("grade::", grade)
                        return loop_elements(rowGrade)?.map(
                          (elementClass, indexClass) =>
                            indexClass === 0 ? (
                              <React.Fragment key={rowGrade[elementClass]?.className}>
                                <tr key={indexClass}>
                                  <td>{indexClass + 1}</td>
                                  <td rowSpan={rowGrade?.length}>{rowGrade[elementClass]?.gradeName}</td>
                                  <td>{rowGrade[elementClass]?.className}</td>
                                  <td>{rowGrade[elementClass]?.studyShift}</td>
                                  <td>{rowGrade[elementClass]?.roomNumber}</td>
                                  <td>{rowGrade[elementClass]?.totalByOldAcademicYear}</td>
                                  {/* <td>0</td> */}
                                  <td>{rowGrade?.[elementClass]?.totalByType}</td>
                                  <td>{rowGrade?.[elementClass]?.totalOldStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalNewStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalReEnrollStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalAddProgrammeStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalChangeProgrammeStudentByGrade}</td>
                                  {rowGrade[
                                    elementClass
                                  ]?.totalByMonth?.map(
                                    (monthElement, indexMonth) => (
                                      <React.Fragment key={indexMonth}>
                                        <td>
                                          {monthElement?.total}
                                        </td>
                                      </React.Fragment>
                                    )
                                  )}
                                </tr>
                              </React.Fragment>
                            ) : loop_elements(rowGrade)?.length ===
                              indexClass + 1 ? (
                              <React.Fragment key={rowGrade[elementClass]?.className}>
                                <tr key={indexClass}>
                                  <td>{indexClass + 1}</td>
                                  <td>{rowGrade[elementClass]?.className}</td>
                                  <td>{rowGrade[elementClass]?.studyShift}</td>
                                  <td>{rowGrade[elementClass]?.roomNumber}</td>
                                  <td>{rowGrade[elementClass]?.totalByOldAcademicYear}</td>
                                  {/* <td>0</td> */}
                                  <td>{rowGrade?.[elementClass]?.totalByType}</td>
                                  <td>{rowGrade?.[elementClass]?.totalOldStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalNewStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalReEnrollStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalAddProgrammeStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalChangeProgrammeStudentByGrade}</td>
                                  {rowGrade[
                                    elementClass
                                  ]?.totalByMonth?.map(
                                    (monthElement, indexMonth) => (
                                      <React.Fragment key={indexMonth}>
                                        <td>
                                          {monthElement?.total}
                                        </td>
                                      </React.Fragment>
                                    )
                                  )}
                                </tr>
                                <tr
                                  key={`សរុប${rowGrade[elementClass]?.gradeName}`}
                                  style={{ backgroundColor: "#ecece0" }}
                                >
                                  <td
                                    align="center"
                                    colSpan={5}
                                  >
                                    សរុប{rowGrade[elementClass]?.gradeName}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalByOldAcademicYear}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalByType}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalOldStudentByGrade}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalNewStudentByGrade}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalReEnrollStudentByGrade}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalAddProgrammeStudentByGrade}
                                  </td>
                                  <td
                                    align="center"
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {grade?.totalChangeProgrammeStudentByGrade}
                                  </td>
                                  {grade?.dataByClass[elementClass]?.totalByMonth?.map(
                                    (monthElement, indexMonth) => {
                                      // console.log("grade?.::", grade)
                                      // console.log("monthElement::", monthElement, grade)
                                      return (
                                        <td key={indexMonth}>
                                          {totalStuByMonthAndGrade(monthElement, grade?.dataByClass)}
                                        </td>
                                      )
                                    }
                                  )}
                                </tr>
                              </React.Fragment>
                            ) : (
                              <React.Fragment key={rowGrade[elementClass]?.className}>
                                <tr key={indexClass}>
                                  <td>{indexClass + 1}</td>
                                  <td>{rowGrade[elementClass]?.className}</td>
                                  <td>{rowGrade[elementClass]?.studyShift}</td>
                                  <td>{rowGrade[elementClass]?.roomNumber}</td>
                                  <td>{rowGrade[elementClass]?.totalByOldAcademicYear}</td>
                                  <td>{rowGrade?.[elementClass]?.totalByType}</td>
                                  <td>{rowGrade?.[elementClass]?.totalOldStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalNewStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalReEnrollStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalAddProgrammeStudentByGrade}</td>
                                  <td>{rowGrade?.[elementClass]?.totalChangeProgrammeStudentByGrade}</td>
                                  {rowGrade[
                                    elementClass
                                  ]?.totalByMonth?.map(
                                    (monthElement, indexMonth) => (
                                      <React.Fragment key={indexMonth}>
                                        <td>
                                          {monthElement?.total}
                                        </td>
                                      </React.Fragment>
                                    )
                                  )}
                                </tr>
                              </React.Fragment>
                            )
                        );
                      })}
                    </>
              }

            </table>
          </Box>

          <Box sx={{ marginTop: "40px", width:"1060px !important" }}>
            {loading ? (
              <Stack
                direction="column"
                justifyContent="center"
                sx={{ height: "400px" }}
              >
                <LoadingPage />
              </Stack>
            ) : (
              <div id="chart">
                <ReactApexChart
                  options={state.options}
                  series={state.series}
                  type="bar"
                  height={400}
                />
              </div>
            )}
          </Box>

          <Stack direction="row" justifyContent="right" sx={{ padding: "20px 100px 0px 0px" }}>
            <Stack direction="column" spacing={0.2}>
              {moment().format("dddd") === "Monday" ? (
                <Typography
                  className="print-student-statistic-classgroup"
                  sx={{ textAlign: "center" }}
                >
                  ថ្ងៃចន្ទ {mondayDateString}
                </Typography>
              ) : (
                <Typography
                  className="print-student-statistic-classgroup"
                  sx={{ textAlign: "center" }}
                >
                  {khmerDateString}
                </Typography>
              )}

              <Typography
                className="print-student-statistic-classgroup"
                sx={{ textAlign: "center" }}
              >
                {`សៀមរាប ថ្ងៃទី${getKhmerNumber(
                  moment().format("DD")
                )} ខែ${getKhmerMonth(
                  moment().format("M")
                )} ឆ្នាំ${getKhmerNumber(moment().format("YYYY"))}`}
              </Typography>
              <Typography
                className="print-student-statistic-classgroup-khmoul"
              >
                បុគ្គលិកផ្នែកចំណូល
              </Typography>
              <Typography
                sx={{ paddingTop: "60px", paddingLeft:"80px" }}
                className="print-student-statistic-classgroup-khmoul"
              >
                ស៊ុន ផាត់សន
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
